export const callWFAPI = async (moduleId: number, type: string, params: object): Promise<any> => {

    const data = {
        id: 1,
        domain: 'websiteforge.com',
        wfuserlogin: 'lgannon',
        wfuserpassword: 'afdJH75fdaA',
        moduleid: moduleId,
        type: type,
        data: params
    };
    const response = await fetch('https://secure.wf-api.com/core/webservice', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
    }
    const resp = await response.json();
    if (resp['ErrorText']) {
        throw new Error(resp['ErrorText']);
    }
    return resp['Data'];
}